import { alpha, SxProps, Theme } from '@mui/material';

export const cardContainerSx: SxProps<Theme> = {
  width: '15.75rem',
  backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerLow,
  border: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '0.625rem',
  padding: '0.625rem 0.75rem',
  boxShadow: (theme) => `0 0.5rem 1.5rem ${alpha(theme.palette.custom.OV.sys.shadow, 0.35)}`,
};

export const copyButtonSx: SxProps<Theme> = {
  marginLeft: 'auto',
  display: 'grid',
  placeItems: 'center',
  width: '1.25rem',
  height: '1.25rem',
  border: 0,
  borderRadius: '0.3125rem',
  padding: 0,
  backgroundColor: 'transparent',
  color: 'inherit',
  cursor: 'pointer',
  opacity: 0,
  transition: 'opacity 120ms',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: (theme) => theme.palette.custom.OV.sys.onBackground,
  },
};

export const kickerSx: SxProps<Theme> = {
  fontSize: '0.625rem',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  flexShrink: 0,
};

export const labelChipSx: SxProps<Theme> = {
  fontSize: '0.625rem',
  lineHeight: 1.4,
  padding: '0.0625rem 0.375rem',
  borderRadius: 999,
  backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export const noteSx: SxProps<Theme> = {
  mt: '0.375rem',
  fontSize: '0.6875rem',
  lineHeight: 1.45,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  '& p': { margin: 0 },
};
